import React from "react";

import FacebookIcon from "public/icons/Facebook.svg";
import ErrorIcon from "public/icons/error_icon.svg";

import { Button } from "@/components/form/Button/Button";
import { SvgIcon } from "@/components/ui/svg-icon/SvgIcon";
import { WithErrorBoundary } from "@/lib/error-boundary/WithErrorBoundary";

import { useFacebookInit } from "./hooks/useFacebookInit";

const FBButton: React.FC = () => {
  const { renderScripts, openFbModal } = useFacebookInit();

  return (
    <Button
      aria-label="Sign in with Facebook Button"
      variant="text"
      className="w-8 h-8 shadow"
      onClick={openFbModal}
    >
      {renderScripts()}
      <SvgIcon width={22} height={22}>
        <FacebookIcon />
      </SvgIcon>
    </Button>
  );
};

const Fallback: React.FC = () => {
  return (
    <Button variant="text" className="w-8 h-8 shadow">
      <SvgIcon>
        <ErrorIcon />
      </SvgIcon>
    </Button>
  );
};

export const FacebookRegistrationButton = WithErrorBoundary(<FBButton />, {
  fallback: <Fallback />,
});
